var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as i0 from "@angular/core";
var GAType;
(function (GAType) {
    GAType["JS"] = "js";
    GAType["Config"] = "config";
    GAType["Event"] = "event";
})(GAType || (GAType = {}));
var GAEventData = /** @class */ (function () {
    function GAEventData() {
    }
    return GAEventData;
}());
export { GAEventData };
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
        // define gtag placeholder: if not defined
        var _window = window;
        if (!_window.gtag) {
            _window.dataLayer = _window.dataLayer || [];
            _window.gtag = function () { _window.dataLayer.push(arguments); };
        }
    }
    // setup analytics for SPA
    AnalyticsService.prototype.init = function (analyticsId) {
        this.analyticsId = analyticsId;
        // config
        this.gtag(GAType.JS, new Date());
        this.gtag(GAType.Config, analyticsId, {
            'send_page_view': false
        });
    };
    AnalyticsService.prototype.logPageView = function (path) {
        this.gtag(GAType.Config, this.analyticsId, {
            'page_path': path
        });
    };
    AnalyticsService.prototype.logEvent = function (action, actionData) {
        this.gtag(GAType.Event, action, actionData);
    };
    AnalyticsService.prototype.gtag = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a;
        (_a = window).gtag.apply(_a, __spread(args));
    };
    AnalyticsService.ngInjectableDef = i0.defineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(); }, token: AnalyticsService, providedIn: "root" });
    return AnalyticsService;
}());
export { AnalyticsService };
